import BigNumber from 'bignumber.js';
import type { DosageUnit } from './constants';
import { DOSAGE_UNIT_SPELLINGS } from './constants';

/** Milligrams in one of each mass unit. An amount converts between two units only when both are listed here. */
const MILLIGRAMS_PER_UNIT = new Map<DosageUnit, number>([
  ['g', 1000],
  ['mg', 1],
]);

/** A unit's singular, e.g. 'gummy' for 'gummies', so the two spellings of one unit compare equal */
const toSingular = (unit: DosageUnit) =>
  DOSAGE_UNIT_SPELLINGS.find((spellings) => spellings.some((spelling) => spelling === unit))?.[0] ?? unit;

/**
 * An amount restated in another unit, e.g. 500 mg as 0.5 g. Undefined when the two units do not measure the same
 * thing (mL against g, or a count of capsules), since there is no correct figure to give.
 */
export const convertDosageUnit = (amount: number, fromUnit: DosageUnit, toUnit: DosageUnit) => {
  if (toSingular(fromUnit) === toSingular(toUnit)) {
    return amount;
  }
  const fromFactor = MILLIGRAMS_PER_UNIT.get(fromUnit);
  const toFactor = MILLIGRAMS_PER_UNIT.get(toUnit);
  if (fromFactor === undefined || toFactor === undefined) {
    return undefined;
  }
  // Dividing last keeps the one inexact step to the end: 1.1 * 1000 is 1100.0000000000002 in plain floating point
  return BigNumber(amount).times(fromFactor).dividedBy(toFactor).toNumber();
};
